export interface ServicePrice {
  normal: number;
  urgent: number;
  enabled: boolean;
}

export interface LaundryItem {
  id: string;
  name: string;
  image: string;
  active: boolean;
  washOnly: ServicePrice;
  ironOnly: ServicePrice;
  washIron: ServicePrice;
}

export const laundryItems: LaundryItem[] = [
  {
    id: 'ITM-01',
    name: 'قميص رجالي',
    image:
      'https://readdy.ai/api/search-image?query=Clean%20flat%20lay%20of%20a%20neatly%20folded%20white%20dress%20shirt%20on%20a%20soft%20light%20gray%20background%2C%20minimal%20product%20photography%2C%20soft%20even%20lighting%2C%20centered&width=96&height=96&seq=laundry-item-shirt-01&orientation=squarish',
    active: true,
    washOnly: { normal: 16, urgent: 24, enabled: true },
    ironOnly: { normal: 12, urgent: 18, enabled: true },
    washIron: { normal: 25, urgent: 35, enabled: true },
  },
  {
    id: 'ITM-02',
    name: 'ثوب رجالي',
    image:
      'https://readdy.ai/api/search-image?query=Clean%20flat%20lay%20of%20a%20crisp%20white%20traditional%20long%20robe%20garment%20on%20a%20soft%20light%20gray%20background%2C%20minimal%20product%20photography%2C%20soft%20even%20lighting%2C%20centered&width=96&height=96&seq=laundry-item-thobe-02&orientation=squarish',
    active: true,
    washOnly: { normal: 18, urgent: 26, enabled: true },
    ironOnly: { normal: 14, urgent: 20, enabled: true },
    washIron: { normal: 28, urgent: 40, enabled: true },
  },
  {
    id: 'ITM-03',
    name: 'بنطلون قماش',
    image:
      'https://readdy.ai/api/search-image?query=Clean%20flat%20lay%20of%20folded%20dark%20formal%20trousers%20on%20a%20soft%20light%20gray%20background%2C%20minimal%20product%20photography%2C%20soft%20even%20lighting%2C%20centered&width=96&height=96&seq=laundry-item-trousers-03&orientation=squarish',
    active: true,
    washOnly: { normal: 20, urgent: 30, enabled: true },
    ironOnly: { normal: 15, urgent: 22, enabled: true },
    washIron: { normal: 30, urgent: 42, enabled: true },
  },
  {
    id: 'ITM-04',
    name: 'عباية',
    image:
      'https://readdy.ai/api/search-image?query=Clean%20flat%20lay%20of%20a%20folded%20black%20elegant%20abaya%20garment%20on%20a%20soft%20light%20gray%20background%2C%20minimal%20product%20photography%2C%20soft%20even%20lighting%2C%20centered&width=96&height=96&seq=laundry-item-abaya-04&orientation=squarish',
    active: true,
    washOnly: { normal: 25, urgent: 38, enabled: true },
    ironOnly: { normal: 20, urgent: 30, enabled: true },
    washIron: { normal: 45, urgent: 60, enabled: true },
  },
  {
    id: 'ITM-05',
    name: 'فستان نسائي',
    image:
      'https://readdy.ai/api/search-image?query=Clean%20flat%20lay%20of%20a%20delicate%20folded%20floral%20dress%20on%20a%20soft%20light%20gray%20background%2C%20minimal%20product%20photography%2C%20soft%20even%20lighting%2C%20centered&width=96&height=96&seq=laundry-item-dress-05&orientation=squarish',
    active: true,
    washOnly: { normal: 30, urgent: 45, enabled: true },
    ironOnly: { normal: 25, urgent: 35, enabled: true },
    washIron: { normal: 50, urgent: 70, enabled: true },
  },
  {
    id: 'ITM-06',
    name: 'بدلة كاملة',
    image:
      'https://readdy.ai/api/search-image?query=Clean%20flat%20lay%20of%20a%20folded%20navy%20business%20suit%20jacket%20and%20trousers%20on%20a%20soft%20light%20gray%20background%2C%20minimal%20product%20photography%2C%20soft%20even%20lighting%2C%20centered&width=96&height=96&seq=laundry-item-suit-06&orientation=squarish',
    active: true,
    washOnly: { normal: 55, urgent: 80, enabled: true },
    ironOnly: { normal: 45, urgent: 65, enabled: true },
    washIron: { normal: 85, urgent: 120, enabled: true },
  },
  {
    id: 'ITM-07',
    name: 'مفرش سرير كبير',
    image:
      'https://readdy.ai/api/search-image?query=Clean%20flat%20lay%20of%20a%20folded%20light%20cream%20bedsheet%20on%20a%20soft%20light%20gray%20background%2C%20minimal%20product%20photography%2C%20soft%20even%20lighting%2C%20centered&width=96&height=96&seq=laundry-item-bedsheet-07&orientation=squarish',
    active: true,
    washOnly: { normal: 28, urgent: 42, enabled: true },
    ironOnly: { normal: 22, urgent: 32, enabled: false },
    washIron: { normal: 45, urgent: 65, enabled: true },
  },
  {
    id: 'ITM-08',
    name: 'بطانية',
    image:
      'https://readdy.ai/api/search-image?query=Clean%20flat%20lay%20of%20a%20folded%20soft%20gray%20blanket%20on%20a%20soft%20light%20gray%20background%2C%20minimal%20product%20photography%2C%20soft%20even%20lighting%2C%20centered&width=96&height=96&seq=laundry-item-blanket-08&orientation=squarish',
    active: true,
    washOnly: { normal: 55, urgent: 75, enabled: true },
    ironOnly: { normal: 0, urgent: 0, enabled: false },
    washIron: { normal: 60, urgent: 85, enabled: false },
  },
  {
    id: 'ITM-09',
    name: 'بشت',
    image:
      'https://readdy.ai/api/search-image?query=Clean%20flat%20lay%20of%20a%20folded%20traditional%20embroidered%20dark%20cloak%20on%20a%20soft%20light%20gray%20background%2C%20minimal%20product%20photography%2C%20soft%20even%20lighting%2C%20centered&width=96&height=96&seq=laundry-item-bisht-09&orientation=squarish',
    active: false,
    washOnly: { normal: 0, urgent: 0, enabled: false },
    ironOnly: { normal: 40, urgent: 60, enabled: true },
    washIron: { normal: 95, urgent: 135, enabled: true },
  },
];

export const defaultExecutionTimes = {
  normal: 48,
  urgent: 12,
};